module.exports = __webpack_public_path__ + "static/media/news.40eb14e3.png";